import { render, staticRenderFns } from "./RhizomePage.vue?vue&type=template&id=1208eed8&"
import script from "./RhizomePage.vue?vue&type=script&lang=ts&"
export * from "./RhizomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports